/**
 * @file card/Card
 * @author chenyaqiu
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import omit from 'rc-util/lib/omit';
import Row from '../row';
import Col from '../col';
import Tabs from '../tabs';
import { ConfigContext } from '../config-provider';
import Meta from './Meta';
import Grid from './Grid';
export const getAction = (actions) => {
    const actionList = actions.map((action, index) => (
    // eslint-disable-next-line react/no-array-index-key
    <li key={`action-${index}`}>
            <span>{action}</span>
        </li>));
    return actionList;
};
export { CardMetaProps } from './Meta';
export { CardGridProps } from './Grid';
;
;
;
const Card = (_a) => {
    var { prefixCls, simple, description, disabled, footerExtra, footerStyle, children, loading, headStyle = {}, bodyStyle = {}, style = {}, bordered = true, isSelected: isCardSelected, onSelect, type, title, extra, cover, actions, actionsExtra, multiMedia, multiMediaPosition = 'left', tabList, activeTabKey, defaultActiveTabKey, tabBarExtraContent, hoverable, tabProps = {}, className = '' } = _a, restProps = __rest(_a, ["prefixCls", "simple", "description", "disabled", "footerExtra", "footerStyle", "children", "loading", "headStyle", "bodyStyle", "style", "bordered", "isSelected", "onSelect", "type", "title", "extra", "cover", "actions", "actionsExtra", "multiMedia", "multiMediaPosition", "tabList", "activeTabKey", "defaultActiveTabKey", "tabBarExtraContent", "hoverable", "tabProps", "className"]);
    const { getPrefixCls, direction } = React.useContext(ConfigContext);
    const cardPrefixCls = getPrefixCls('card', prefixCls);
    const divProps = omit(restProps, ['onTabChange']);
    const [isSelected, setIsSelected] = useState(isCardSelected);
    const isContainGrid = () => {
        let containGrid;
        React.Children.forEach(children, (element) => {
            if (element && element.type && element.type === Grid) {
                containGrid = true;
            }
        });
        return containGrid;
    };
    const onTabChange = (key) => { var _a; return (_a = restProps.onTabChange) === null || _a === void 0 ? void 0 : _a.call(restProps, key); };
    const handleCardClick = () => {
        onSelect && onSelect(divProps);
    };
    const loadingBlockStyle = (bodyStyle === null || bodyStyle === void 0 ? void 0 : bodyStyle.padding) === 0 || (bodyStyle === null || bodyStyle === void 0 ? void 0 : bodyStyle.padding) === '0px' ? { padding: 24 } : undefined;
    const block = <div className={`${cardPrefixCls}-loading-block`}/>;
    const loadingBlock = (<div className={`${cardPrefixCls}-loading-content`} style={loadingBlockStyle}>
            <Row gutter={8}>
                <Col span={22}>{block}</Col>
            </Row>
            <Row gutter={8}>
                <Col span={8}>{block}</Col>
                <Col span={15}>{block}</Col>
            </Row>
            <Row gutter={8}>
                <Col span={6}>{block}</Col>
                <Col span={18}>{block}</Col>
            </Row>
            <Row gutter={8}>
                <Col span={13}>{block}</Col>
                <Col span={9}>{block}</Col>
            </Row>
            <Row gutter={8}>
                <Col span={4}>{block}</Col>
                <Col span={3}>{block}</Col>
                <Col span={16}>{block}</Col>
            </Row>
        </div>);
    const hasActiveTabKey = activeTabKey !== undefined;
    const extraProps = Object.assign(Object.assign({}, tabProps), { [hasActiveTabKey ? 'activeKey' : 'defaultActiveKey']: hasActiveTabKey ? activeTabKey : defaultActiveTabKey, tabBarExtraContent });
    let head;
    let footer;
    let body;
    const coverDom = cover ? <div className={`${cardPrefixCls}-cover`}>{cover}</div> : null;
    const actionDom = actions && actions.length ? (<ul className={`${cardPrefixCls}-actions`}>{getAction(actions)}</ul>) : null;
    const actionsExtraDom = actionsExtra && actionsExtra.length ? (<ul className={`${cardPrefixCls}-actionsExtra`}>{getAction(actionsExtra)}</ul>) : null;
    const actionRender = actionDom || actionsExtraDom ? (<div className={`${cardPrefixCls}-actions-wrap`}>
            {actionDom}
            {actionsExtraDom}
        </div>) : null;
    const tabs = tabList && tabList.length ? (<Tabs size="large" {...extraProps} className={`${cardPrefixCls}-head-tabs`} onChange={onTabChange}>
            {tabList.map(item => (<Tabs.TabPane tab={item.tab} disabled={item.disabled} key={item.key}/>))}
        </Tabs>) : null;
    if (children) {
        body = (<div className={`${cardPrefixCls}-body`} style={bodyStyle}>
                {loading ? loadingBlock : children}
            </div>);
    }
    if (title || extra || tabs) {
        const titleClassName = classNames(`${cardPrefixCls}-head-title`, { [`${cardPrefixCls}-head-title-with-tabs`]: !!tabs });
        const extraClassName = classNames(`${cardPrefixCls}-head-extra`, { [`${cardPrefixCls}-head-extra-with-tabs`]: !!tabs });
        head = (<div className={`${cardPrefixCls}-head`} style={headStyle}>
                <div className={`${cardPrefixCls}-head-wrapper`}>
                    {title && <div className={titleClassName}>{title}</div>}
                    {extra && <div className={extraClassName}>{extra}</div>}
                </div>
                {tabs}
            </div>);
    }
    if (description || footerExtra) {
        footer = (<div className={`${cardPrefixCls}-footer`} style={footerStyle}>
                <div className={`${cardPrefixCls}-footer-wrapper`}>
                    {description && <div className={`${cardPrefixCls}-footer-description`}>{description}</div>}
                    {footerExtra && <div className={`${cardPrefixCls}-footer-extra`}>{footerExtra}</div>}
                </div>
            </div>);
    }
    const simpleCardRedner = (<div className={`${cardPrefixCls}-simple-con`}>
            {body}
            <div className={`${cardPrefixCls}-simple-con-description`}>
                {description}
            </div>
        </div>);
    const cardRender = (<div className={`${cardPrefixCls}-con ${multiMedia ? 'hasImage' : ''} ${multiMediaPosition}`}>
            {!!multiMedia && <div className={`${cardPrefixCls}-con-image ${multiMediaPosition}`}>{multiMedia}</div>}
            <div className={`${cardPrefixCls}-con-wrap ${multiMedia ? `${multiMediaPosition === 'left' ? 'right' : 'left'}` : ''}`}>
                {head}
                {coverDom}
                {body}
                {footer}
                {actionRender}
            </div>
        </div>);
    const classString = classNames(cardPrefixCls, {
        [`${cardPrefixCls}-loading`]: loading,
        [`${cardPrefixCls}-bordered`]: bordered,
        [`${cardPrefixCls}-hoverable`]: hoverable,
        [`${cardPrefixCls}-contain-grid`]: isContainGrid(),
        [`${cardPrefixCls}-contain-tabs`]: tabList && tabList.length,
        [`${cardPrefixCls}-type-${type}`]: !!type,
        [`${cardPrefixCls}-rtl`]: direction === 'rtl',
        [`${cardPrefixCls}-simple`]: simple,
        [`${cardPrefixCls}-selected`]: isSelected,
        [className]: !!className
    });
    useEffect(() => {
        isCardSelected !== undefined && setIsSelected(isCardSelected);
    }, [isCardSelected]);
    return (<div {...divProps} className={classString} aria-disabled={simple && disabled} style={style} onClick={handleCardClick}>
            {simple ? simpleCardRedner : cardRender}
        </div>);
};
Card.Grid = Grid;
Card.Meta = Meta;
export default Card;
